module.exports = __webpack_public_path__ + "static/img/wechat-exp.83036b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/wechat-exp.png
// module id = 7h3B
// module chunks = 0